$(document).ready(function() {
	bindDatePicker();
	bindRoomSelector();
			
	if(siteId == 1){
		$("#poPhone").mask("(999) 999-9999");
	}else{
		$("#poPhone").mask("999999999999999");
	}
	
	$("#gsm_code").intlTelInput({
		preferredCountries: [countryCode],
		americaMode: false
	});


	$("#gsm_code").focusout(function(){
		var isTR = $("[name=gsm_code]").val().includes("+90");
		if(isTR){
			$("[name=poPhone]").mask("(999) 999-9999");
		}else{
			$("[name=poPhone]").mask("999999999999999");
		}
	});
	
	$("#formPo").letterCase($.cookie('siteLocale')).validate({
		focusInvalid: false				
	});
	
	$( ".roomSelect" ).spinner({});
	$( ".adultCount" ).spinner({});
	$( ".childCount" ).spinner({});
	$( ".childAge" ).spinner({});
	
	$(".roomSelect, .adultCount, .childCount, .childAge").on("spinstop",function(){
		$(this).change();
	});		
		
	$(".travelerSelect").click(function() {
		$(this).closest("form").find('.guestList').toggle("fade","fast");
		return false;
	});
	$('body').click(function(event) {
		if (!$(event.target).closest('.guestList').length) {
			$('.guestList,.mob-modal').hide();
		};
	});	
	$(".pop-close-btn,.pop-btn-ok").click(function() {
		$('.guestList,.mob-modal').hide();
		return false;
	});
	
	$.widget("custom.catcomplete", $.ui.autocomplete, {
		_renderMenu : function(ul, items) {
			var that = this, currentCategory = "";
			$.each(items, function(index, item) {

				if (item.category != currentCategory) {

					if (item.category == "HOTEL") {
						ul.append("<li class='ui-autocomplete-category ui-state-disabled iconHotel' >" + FmtMessage.getMessage('js.result.hotel') + "</li>");
					} else if (item.category == "CITY") {
						ul.append("<li class='ui-autocomplete-category ui-state-disabled iconCity' >" + FmtMessage.getMessage('js.result.city') + "</li>");
					} else if (item.category == "DISTRICT") {
						ul.append("<li class='ui-autocomplete-category ui-state-disabled iconDistrict' >" + FmtMessage.getMessage('js.result.district') + "</li>");
					}

					currentCategory = item.category;
				}
				that._renderItemData(ul, item);
			});
		},
        _renderItem: function (ul, item) {
    		item.label = item.value.replace(re, "<span class='searchTerm'>$1</span>");
    		return $("<li class='ui-autocomplete-item'></li>")
    			.data("ui-autocomplete-item", item)
    			.append("<a>" + item.label + "</a>")
    			.appendTo(ul);
    		}
	});
	 
	
	var re = null;
	$("#poHotel").catcomplete(
	{   delay: 500,
		source : function(request, response) {
			$.ajax({
				url : "/hotel/hotels",
				dataType : "json",
				data : {
					output : 'json',
					results : 100,
					query : request.term
				},
			

				success: function(data) {
					if(data == null){
						data = [];
					}
					
					var itemList = $.map(data, function(item) {
							if (item.type == "HOTEL") {
								return {
									value: item.name + " ( " + item.hotelCount + " "+ FmtMessage.getMessage('js.title.hotel.name') + " ) ",
									key: item.id,
									category : item.type,
									name : item.name
								};
							}
					});
					re = new RegExp("(" + $.ui.autocomplete.escapeRegex(request.term) + ")", "gi");
					
					var itemListNew = getHotelItemLabels(itemList);
					response(itemListNew);
				}
				
				
				
			});
		},
		minLength : 2,
		select: function (a, b) {
			// $(this).val(b.item.value);
			// alert(b.item.key);
			$("#poAutocompleteId").val(b.item.key);
			$(this).data("autoCompleteResult", b.item.value);
		}
	}).change(function (event) {
		if ($(this).data("autoCompleteResult") != this.value)
			$('[name="id"]', this.form).val("");
	});

	$.ui.autocomplete.prototype._renderItem = function (ul, item) {
		item.label = item.value.replace(re, "<span class='searchTerm'>$1</span>");
		return $("<li></li>")
			.data("ui-autocomplete-item", item)
			.append("<a>" + item.label + "</a>")
			.appendTo(ul);
		};

});

function getHotelItemLabels(itemList){
	
	var itemListNew = $.map(itemList, function(item) {
		var category = item.category;
		if (category == "HOTEL"){
			item.value = item.name;
		}
		return item;
	});
	
	return itemListNew;
}

function bindDatePicker(context) {
	
	if (context == undefined)
		context = document;
	
	var now = new Date();
	var aYearLater = new Date(now.getFullYear() + 1, now.getMonth(), now.getDate());
	
	$("#poCheckin", context).datepicker({
		dateFormat : "dd.mm.yy",
		showButtonPanel: true,
		numberOfMonths : (navigator.userAgent.match(/iPhone/i)) ? 12 : 1,
        closeText: "x",
		minDate : new Date(),
		maxDate : aYearLater,
		onSelect : function(dateText, inst) {
			
			var selDate = $.datepicker.parseDate("dd.mm.yy", dateText);
			$("#poCheckin", context).datepicker("setDate", selDate);
			
			var $checkOutDate = $('#poCheckout', this.form);
			var endDateStr = $checkOutDate.val();
			var endDate = null;
			if (endDateStr != "")
				endDate = $.datepicker.parseDate("dd.mm.yy", endDateStr);
			$("#poCheckout", context).datepicker("option", "minDate", selDate);
			if (endDate == null || selDate.getTime() >= endDate.getTime()) {
				var newEndDate = new Date(selDate);
				newEndDate.setDate(newEndDate.getDate() + 6);
				$("#poCheckout", context).datepicker("setDate", newEndDate);
			}
			$(this).blur();
		},
		onClose : function (){
			if (navigator.appName == 'Microsoft Internet Explorer') {
				e.preventDefault();
	          }
		}
	});
	
	
	var minDate = null;
	var minDateStr = $("#poCheckin:first", context).val();
	minDateStr == "" ? minDate = new Date():minDate = $.datepicker.parseDate("dd.mm.yy",minDateStr);
	minDate.setDate(minDate.getDate() + 1);
	var maxDate = new Date();
	maxDate.setFullYear(minDate.getFullYear() + 1);
	$("#poCheckout", context).datepicker({
		dateFormat : "dd.mm.yy",
		showButtonPanel: true,
		numberOfMonths : (navigator.userAgent.match(/iPhone/i)) ? 12 : 1,
        closeText: "x",
		minDate : minDate,
		maxDate : maxDate,
		onSelect : function (dateText, inst) {
			
			var selDate = $.datepicker.parseDate("dd.mm.yy", dateText);
			$("#poCheckout", context).datepicker("setDate", selDate);
			$(this).blur();
		},
		onClose : function (){
			if (navigator.appName == 'Microsoft Internet Explorer') {
				e.preventDefault();
	          }
		}
	});

}

function bindRoomSelector(context) {
	
	if (context == undefined)
		context = document;
	
	$(".roomSelect", context).on('change', function(event) {

		var roomCount = $(this).val();
		$(".roomSelect").val(roomCount);
		$(".travelerSelectRoom").html(roomCount);
		for ( var i = 1; i < 5; i++) {
			if (i <= roomCount) {
					$(".room" + i).show();
			} else {
					$(".room" + i).hide();
			}
		}
//				$(this).closest("form").find(".travelerSelectRoom").html(roomCount);
		setTotalGuest($(this).closest("form"));
		
		var locale = $.cookie('siteLocale');
		if(locale == "en" && roomCount > 1){
			$(".travelerRoomFmt").html(hotelSelectMsg.rooms);
//					$(this).closest("form").find(".travelerRoomFmt").html(hotelSelectMsg.rooms);
		}else{
			$(".travelerRoomFmt").html(hotelSelectMsg.room);
//					$(this).closest("form").find(".travelerRoomFmt").html(hotelSelectMsg.room);
		}
		
	}).change();

	$(".childCount", context).on('change', function (event) {

		var childCount =  parseInt(this.value);
		var index = this.name.split('_')[1];
		$("[name="+this.name+"]").val(childCount);

		for ( var i = 1; i < 4; i++) {
			if (i <= childCount) {
				$(".childAge" + index + i).show();
			} else {
				$(".childAge" + index + i).hide();
			}
		}
		
		setTotalGuest($(this).closest("form"));
        
	}).change();
	
	$(".adultCount", context).on('change', function (event) {
		$("[name="+this.name+"]").val(parseInt(this.value));
		setTotalGuest($(this).closest("form"));
	}).change();
	
	$(".childAge", context).on('change', function (event) {
		$("[name="+this.name+"]").val(parseInt(this.value));
	}).change();
	
}

function setTotalGuest(form) {
	var roomCount = parseInt(form.find("#glRoomCount").val());
	var totalAdultCount = 0;
	var totalChildCount = 0;
	for ( var i = 1; i <= roomCount; i++) {
		totalAdultCount = totalAdultCount + parseInt(form.find("[name=adultCount_" + i + "]").val());
		totalChildCount = totalChildCount + parseInt(form.find("[name=childCount_" + i + "]").val());
	}
	var totalGuest = totalAdultCount + totalChildCount;
	$(".travelerSelectGuest").html(totalGuest);
//			form.find(".travelerSelectGuest").html(totalGuest);
	var locale = $.cookie('siteLocale');
	if(locale == "en" && totalGuest > 1){
		$(".travelerGuestFmt").html(hotelSelectMsg.guests);
//				form.find(".travelerGuestFmt").html(hotelSelectMsg.guests);
	}else{
		$(".travelerGuestFmt").html(hotelSelectMsg.guest);
//				form.find(".travelerGuestFmt").html(hotelSelectMsg.guest);
	}
}

function sendInfo(){
	var email = $("#email").val();
	var gsm = $("#poPhone").val();
	var isEmailValid = emailValidation('email');
	if(grecaptcha.getResponse().length == 0){
		alert(FmtMessage.getMessage('js.check.googlecaptcha.warn'));
		return false;
	}
	if (!isEmailValid) {
		grecaptcha.reset();
		return false;
	}	
	if (email == "") {
		alert(FmtMessage.getMessage('js.invite.emptyEmail.warn'));
	}else{
		var url = "/hotel/priceoffer";
		$('#formPo').attr('action', url).submit();
	}
	grecaptcha.reset();
}
